/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { getButtonClassName } from "./utils";

export const ProductCardDefault = ({
  titleText,
  subTitleText,
  buttonText,
  redirectUrl,
  imageSrc,
  belowBreakpoint,
}) => {
  const history = useHistory();
  return (
    <div>
      <div
        className="border rounded-md overflow-hidden border-neutral-300 hover:border-neutral-700"
        onClick={() => belowBreakpoint && history.push(redirectUrl)}
      >
        <img src={imageSrc} alt="" />
        <div className="p-5 md:p-10">
          <div className="text-2xl font-bold">{titleText}</div>
          <div className="text-md">{subTitleText}</div>
          {!belowBreakpoint && <div className="mt-5">
            <Link
              to={redirectUrl}
              className={getButtonClassName()}
              style={{ maxWidth: 202 }}
            >
              {buttonText}
            </Link>
          </div>}
        </div>
      </div>
    </div>
  );
};
